export const StyleForHowItWorksModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '10px',
  bgcolor: 'background.paper',
  boxShadow: 24,
};
export const StyleForJunModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '10px',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
};

export const StyleForPopup = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '10px',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 3,
};
export const StyleForReviewCall = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '10px',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  overflowY: 'scroll',
  paddingBottom: '20px',
};
export const StyleForRecieveCall = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '10px',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  overflowY: 'scroll',
  padding: '20px',
};
export const StyleForInSufBalance = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '10px',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 3,
};

export const FisrtloginStyle = {
  position: 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '10px',
  bgcolor: 'background.paper',
  boxShadow: 24,
};
